import { render, staticRenderFns } from "./MedServicePayment.vue?vue&type=template&id=214f6854&scoped=true"
import script from "./MedServicePayment.vue?vue&type=script&lang=js"
export * from "./MedServicePayment.vue?vue&type=script&lang=js"
import style0 from "./MedServicePayment.vue?vue&type=style&index=0&id=214f6854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214f6854",
  null
  
)

export default component.exports